import { useState } from "react";
import { Mail, Lock, Eye, EyeOff, ArrowLeft, Shield } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { ButtonLoader } from "../components/LoadingSpinner";
import { InlineError } from "../components/ErrorAlert";

// Web ini sekarang khusus admin/dokter — login "Ibu Nifas" dihapus karena
// pasien sudah pindah sepenuhnya ke aplikasi Android.
export default function LoginPage({ onBack }) {
  const { loginAdmin, loading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await loginAdmin(email, password);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-800 via-primary-700 to-primary-900 flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute top-10 right-10 w-72 h-72 rounded-full bg-white/5 blur-3xl" />
      <div className="absolute bottom-10 left-10 w-96 h-96 rounded-full bg-accent-500/10 blur-3xl" />

      <div className="w-full max-w-md relative z-10">
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-white/70 hover:text-white text-sm mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Kembali ke Beranda
          </button>
        )}

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-primary-800 to-primary-700 p-8 text-center">
            <div className="w-16 h-16 rounded-2xl bg-white/80 backdrop-blur-sm flex items-center justify-center mx-auto mb-4 shadow-lg">
              <img
                src="/logo_splash2.png"
                alt="SmartMoms Logo"
                className="w-11 h-11 object-contain"
              />
            </div>
            <h1 className="font-display font-800 text-2xl text-white">
              Smart<span className="text-accent-300">Moms</span>
            </h1>
            <p className="text-white/70 text-sm mt-1">Panel Admin & Dokter</p>
          </div>

          <div className="p-8">
            <div className="flex items-center gap-2 bg-primary-50 text-primary-800 text-sm font-semibold px-4 py-2.5 rounded-xl mb-6">
              <Shield className="w-4 h-4" />
              Masuk untuk mengakses panel admin
            </div>

            <InlineError message={error} />

            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Email
                </label>
                <div className="relative">
                  <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@smartmoms.id"
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Password
                </label>
                <div className="relative">
                  <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type={showPass ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    className="w-full pl-10 pr-12 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPass(!showPass)}
                    className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPass ? (
                      <EyeOff className="w-4 h-4" />
                    ) : (
                      <Eye className="w-4 h-4" />
                    )}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-primary-800 hover:bg-primary-900 disabled:opacity-60 text-white font-semibold rounded-xl transition-all shadow-sm flex items-center justify-center gap-2 mt-2"
              >
                {loading ? (
                  <>
                    <ButtonLoader /> Memverifikasi...
                  </>
                ) : (
                  "Masuk"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
